import React, { Component } from "react";
import { API, Storage } from "aws-amplify";
import config from "../config";
import "./CommentsWidget.css";
import moment from "moment";


export default class CommentsWidget extends Component {

    constructor(props){
      super(props);
      this.state={
        errorMsg: "",
        blogId: this.props.blog.blogId,
        comment: "",
        commentsFromServer: "",
        deleteCommentId: "",
        isSending: false
      }

    }

    async componentDidMount(){

      try{
        this.loadCommentsFromServer();

      }catch(e){
        this.setState({errorMsg: e.message});
      }

    }


    async loadCommentsFromServer(){
      const blogComments = await this.getBlogComments();
      var commentsWithProfilePic = []
      for(var i = 0 ; i < blogComments.length; i++){
        var eachComment = blogComments[i];
        if(eachComment.profilePic && eachComment.profilePic.length > 0){
          eachComment.profilePicUrl = await this.getProfileImageUrl(eachComment.profilePic);
        }
        commentsWithProfilePic.push(eachComment);

      }
      this.setState({commentsFromServer: commentsWithProfilePic}) ;

    }

    async getProfileImageUrl(profilePic){
        var profilePicPath = await Storage.get(profilePic);
        return profilePicPath;
    }

    getBlogComments(){
      return API.get("retnetindia", "/blogs/" + this.state.blogId + "/comments");
    }

    async getUserProfileFromServer(){
      return await API.get("retnetindia", "/user/profile");
    }

    postBlogComments(commentDetails){
      return API.post("retnetindia", "/blogs/" + this.state.blogId + "/comments",{
        body: commentDetails
      });
    }

    handleChange = event => {
      this.setState({
        comment: event.target.value
      });
    }

    handleKeyPress = async event =>{

      if(event.key === 'Enter'){
        //this.sendCommentToServer();
      }
    }

    async sendCommentToServer(){
      if(this.state.comment.length === 0){
        return;
      }

      try{

         await this.postBlogComments({
           comment: this.state.comment
         });
         this.setState({ comment: "", isSending: false});
         this.loadCommentsFromServer();


      }catch(e){
        this.setState({isSending: false, errorMsg: e.message});

      }
    }

    handleSendButton = async event => {
      event.preventDefault();
      this.setState({isSending: true});
      this.sendCommentToServer();


    }

    getProfilePicElement(userProfile){

      const profilePicElement = userProfile && userProfile.profilePicUrl && userProfile.profilePicUrl.length > 0
                                      ? <img className="comments-author-image" src={""+userProfile.profilePicUrl} />
                                      :   <i className="fa fa-user comments-author-image"></i>;
      return profilePicElement;
    }

    deletCommentTrigger = event => {
      this.setState({deleteCommentId: event.target.id });
    }

    deleteComment= async event => {
        try{

          var retValue = await API.del("retnetindia", "/deletecomment/"+this.props.blog.blogId+"/comments/"+this.state.deleteCommentId);
          this.loadCommentsFromServer();

        }catch(e){
          if(e.response.data.error){
            this.setState({errorMsg: e.response.data.error});
          }else{
            this.setState({errorMsg: e.message});
          }

        }

    }

    renderDeleteIcon(eachComment){
      if(!this.props.blog || !this.props.userProfile ){
        return(
          <span></span>
        );
      }

      if(eachComment.userId === this.props.userProfile.userId || (this.props.userProfile.role && this.props.userProfile.role === "su")){

        return(
          <i  className="fa fa-trash pull-right comment-delete" id={eachComment.commentId}
                    aria-hidden="true"
                    data-toggle="modal" onClick={this.deletCommentTrigger} data-target={"#delete-comment-"+this.props.blog.blogId}></i>
        );
      }
      return(
        <span></span>
      );
    }

    renderModalDialog(){
      return(
        <div className="modal fade" id={"delete-comment-"+this.props.blog.blogId} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" >Delete Blog Confirmation</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                     You cannot get it back once deleted. <br /> Do you want to delete the comment?
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-primary" data-dismiss="modal">Cancel</button>
                    <button type="button" className="btn btn-danger" onClick={this.deleteComment} data-dismiss="modal">Delete</button>
                  </div>
                </div>
              </div>
        </div>
      );
    }


    renderEachComment(eachComment){

        const profilePicElement = this.getProfilePicElement(eachComment);

          return(
            <div key={eachComment.commentId} className="each-comment">
                <p> { profilePicElement } </p>
                <div className="comment-section">
                    <p>
                      <b className="comments-author-name">
                      {eachComment.commenter} </b> &nbsp;
                       - {eachComment.comment} &nbsp; &nbsp;
                      [{moment(eachComment.createdAt).fromNow()}]


                    </p>

                </div>
                {this.renderDeleteIcon(eachComment)}
            </div>
          );
    }

    getErrorElement(){
      return this.state.errorMsg && this.state.errorMsg.length > 0
                               ? <div class="alert alert-danger" role="alert">
                                   {this.state.errorMsg}
                                 </div>
                               : "";
    }

    render = () => {
      var comments = []
      var commentsFromServer = this.state.commentsFromServer;
      if(commentsFromServer.length > 0){
        commentsFromServer.sort(function(comment1, comment2){
            var keyA = new Date(comment1.createdAt),
                keyB = new Date(comment2.createdAt);
            // Compare the 2 dates
            if(keyA < keyB) return -1;
            if(keyA > keyB) return 1;
            return 0;
        });
      }


      for(var i = 0 ; i < commentsFromServer.length; i++){
        comments.push(this.renderEachComment(commentsFromServer[i]));
      }

      return(
        <div>
         <b>Comments</b>

            {comments}
            {this.getErrorElement()}
             <div className="each-comment container">
                 {this.getProfilePicElement(this.props.userProfile)}
                 <div className="comment-section">

                      <textarea className="blog-add-comment-input col-xs-6"
                          onChange={this.handleChange}
                          value={this.state.comment}
                          id={"add-comments-text-"+this.state.blogId}
                          onKeyPress={this.handleKeyPress}
                          placeholder="Please write your comment.."
                           rows="3"/>

                      <button className="btn btn-success add-comment"
                          id={"add-comments-btn-"+this.state.blogId}
                          onClick={this.handleSendButton}>
                           Send &nbsp;
                          {this.state.isSending ? <i className="fa fa-refresh fa-spin"></i>
                                                 : <span></span>
                          }

                      </button>
                 </div>
             </div>
             {this.renderModalDialog()}
         </div>

      );
    }

}



// WEBPACK FOOTER //
// ./src/containers/CommentsWidget.js